import { type ReactNode } from 'react'

/** Caption marking a tab body as workspace-wide, so the scope is legible without reading the data. */
export function ScopeNote({ children }: { children: ReactNode }) {
  return (
    <div style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--text3)', letterSpacing: '0.08em', marginBottom: 10 }}>
      // {children}
    </div>
  )
}
